import AddSvg from '../assets/img/svg/add'

const TopBarWebhooks = ({ callback }) => {
  return (
    <div className="top-bar">
      <h2>Webhooks</h2>
      <div className="top-bar-flex">
        <div className="top-bar-btn" onClick={callback}>
          <AddSvg />
          <span>New webhook</span>
        </div>
      </div>
    </div>
  )
}

export default TopBarWebhooks
